<template>
	<div class="page">
		<HeaderBar title="治疗方案"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group title="抗HCV治疗方案">
					<van-row>
						<StaticSingleSelect label="治疗方案" :selectkey.sync="form.bq421.Bq421_002" :list="existList" />
						<FormNormalInput label="说明" v-model="form.bq421.Bq421_004"
							v-show="form.bq421.Bq421_002 == '其他'" />
					</van-row>
					<van-row v-show="false">
						<FormNormalInput label="药物一、" readonly/>
						<FormNormalInput label="药物名称" v-model="form.bq421.Bq421_002"/>
						<FormNormalInput label="用法用量" v-model="form.bq421.Bq421_003" />
					</van-row>
					<van-row v-show="false">
						<FormNormalInput label="药物二、" readonly/>
						<FormNormalInput label="药物名称" v-model="form.bq421.Bq421_004"/>
						<FormNormalInput label="用法用量" v-model="form.bq421.Bq421_005" />
					</van-row>
				</van-cell-group>
				<van-cell-group title="疗程">
					<van-row>
						<FormNormalInput label="疗程" v-model="form.bq421.Bq421_006"/>
					</van-row>
				</van-cell-group>

				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq421.guid'>
				</FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate && bq400.Bq400_996=="0"'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq421.guid != ''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
// 引入服务组件
import componentsModel from '../../../base/components.js'
// 引入子页面的混入对象
import mixinModel from '../mixins/mixins.js'
export default {
	name: "page015",
	mixins: [mixinModel],
	data() {
		return {
			modelname: 'bq421',
			form: {
				bq421: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间					
					Bq400_guid: '', //随访基本信息表编号
					Bq421_002: '', //
					Bq421_003: '', //
					Bq421_004: '', //
					Bq421_005: '', //
					Bq421_006: '', //
				},
				sempFiles: []
			},
			fullscreenLoading: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq421/Save',
			dataList: [],
			existList: [{id: '磷酸依米他韦100mg+索磷布韦片400mg，一天一次，连续12周', name: '磷酸依米他韦100mg+索磷布韦片400mg，一天一次，连续12周'}, {id: '其他', name: '其他'}],
			bq400: JSON.parse(sessionStorage.getItem('bq400')),
			savestate: false,
		}
	},
	components: {
		...componentsModel
	},
	methods: {
		//加载信息
		LoadInfo: function () {
			var that = this
			var args = {
				bq400guid: this.bq400.guid
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq421/Info', args, function (d) {
				let dataModel = d.Data
				if (dataModel != null) {
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$set(that.form, "bq421", dataModel)
				}
			}, null, null, null);
		},

		//保存信息
		SaveInfo: function () {
			let that = this
			if(that.form.bq421.Bq421_002 != '其他'){
				that.form.bq421.Bq421_004=''
			}
			that.form.sempFiles = that.$refs.normalUpload.GetFileList()
			that.$refs.btnSave.Save()
		},
	},
	mounted() {
		this.form.bq421.Bq400_guid = this.bq400.guid
		//this.existList = this.$utils.setStandardList(this.$apis.s400Apis.existList)
		this.LoadInfo()
	}
}
</script>

<style scoped>
.unit {
	padding-top: 0.5rem;
	color: #999;
	font-size: 0.9em;
}
</style>
